/**
 * 共通メソッド 
 */

// Ionic
import { loadingController } from '@ionic/vue';
// Capacitor
import { Capacitor } from '@capacitor/core';
// Vue
import axios from 'axios';
import router from '@/router';
import { ref } from 'vue';

// Google Maps
// import { GoogleMap, Marker } from "vue3-google-map";
import {Loader} from 'google-maps';

// メモった！、キニッタ！共通
import * as JC from '@/components/00/JsonContainer';    // 通信用Jsonコンテナ
import * as GVar from '@/components/00/Var00';          // 共通変数
import * as Const00 from '@/components/00/properties/Const00';  // 共通定数
import * as Msg00Ja from '@/components/00/properties/Message00_ja'; // 共通メッセージ

/*
 * メモった！、キニッタ！専用スクリプト
 * ユーザー情報、ローカルファイルシステムへのアクセス等
 * このスクリプトはcordova、env.jsより後に読み込むこと
 */

let ui: any = null;  			        // ユーザー情報(memotta.android.container.M109003JC)
const loggedin = ref(false);			 // ユーザーログイン状況(true, false)
// サーブレットからの戻り値（サーブレットを呼び出すたびに上書きされる）
let serverSttsCd: any = null;			// サーブレットからの最新のステータスコード
let serverMsg = "";					    // サーブレットからの最新のメッセージ

/**
 * デバッグ状態を返す
 */
export const isDebugEnabled = function ()
{
    return (GVar.debugEnabled);
}

export const getUiKey = function ()
{
	// return(sysCd+tmpltCd+"@"+GVar.ui_key_prefix);
    return(GVar.sysCd+GVar.tmpltCd+"@"+GVar.ui_key_prefix);
}

/**
 * ユーザー情報オブジェクトを返す
 * ユーザー情報オブジェクト：memotta.android.container.M109003JC
 * 
 * @return ui ユーザー情報オブジェクト
 */
export const getUi = function ()
{
	return(ui);
}

/**
 * ユーザー情報オブジェクトをセットする
 * ユーザー情報オブジェクト：memotta.android.container.M109003JC
 * 
 * @param ui ユーザー情報オブジェクト
 */
export const setUi = function (val: any)
{
	ui = val;
	if ( ui != null && ui.nckNm != null )
	{
		ui.nckNm.value = decodeURI(ui.nckNm.value);
	}
}

/**
 * 0埋めした6桁のユーザー番号を返す
 * @param uid ユーザーID
 */
export function getFullUid(uid: string)
{
    return("000000" + uid).slice(-6);
}

/**
 * バーコードをスキャンして取得した会員番号からスタート、ストップキャラクターと
 * 先頭の0を削除した会員番号（ユーザーID）を返す
 * 入力例）A000234A
 * @param uid バーコードをスキャンして取得した会員番号
 * @returns ユーザーID 
 */
export function getRealUidFromScannedUid(uid: string)
{
    if ( uid == null || uid.length < 3 ) { return null; }
    // バーコードでスキャンした会員番号からスタート、ストップキャラクターを外す
    uid = uid.substring(1);
    uid = uid.substring(0,uid.length-1);
    // 先頭の０を外す
    const uidNum = Number(uid);
    return uidNum.toString();
}

/**
 * メモった！、キニッタ！共通(Cont00, Message00_ja)のプロパティーの値を返す
 * 
 * @param key キー
 * @param 置換文字列(可変パラメーター)
 * @returns 値, null
 */
export function getProperty (key: string, ...reps: string[])
{
    let str = null;
    // 共通Constを検索
    if ( null == (str = Const00.map.get(key)) )
    {
        // 共通メッセージを検索
        str = Msg00Ja.map.get(key);
    }
    if ( str != null )
    {
        // メッセージの場合、文字列の置き換えを行う
        reps.forEach( function(item, index)
        {
            str = eval("str.replace(/\\{\\$"+(index+1)+"\\}/g, item)");
        });
    }
    return str;
}

/**
 * ユーザーのログイン状況を返す
 * 
 * @returns true - ログイン済み、 false - ログインしてない
 */
export const isLoggedin = 
function ()
{
	return(loggedin.value);
}

/**
 * ユーザーのログイン状況をセットする
 * 
 * @param b ログイン状況 true又はfalse
 */
export const setLoggedin =
function (b: boolean)
{
	loggedin.value = b;
}

/**
 * サーブレットからのステータスコード取得する
 */
export const getServerSttsCd =
function ()
{
	return(serverSttsCd);
}

/**
 * 	サーブレットからのステータスコードをセットする
 * 
 * @param ステータスコード
 */
export const setServerSttsCd =
function (val: string)
{
	serverSttsCd = val;
}

/**
 * サーブレットからのメッセージ取得する
 */
export const getServerMsg =
function ()
{
	return(serverMsg);
}

/**
 * 	サーブレットからのメッセージをセットする
 * 
 * @param メッセージ
 */
export const setServerMsg =
function (val: string)
{
	serverMsg = val;
}

/**
 * ローカル変数、sessionstorageに保存されているユーザー固有の情報を削除する
 */
export const clearUserData =
function ()
{
	// sessionstorageを全て削除する
	sessionStorage.clear();
	// uiオブジェクトにnullをセット
	setUi(null);
}

/**
 * 引数の文字列が含まれるキーを持つデータを削除する
 *
 * @param str キーの一部
 */
export const removeSessionstorage =
function (str: string)
{
    for( const key in sessionStorage )
    {
        if ( 0 <= key.indexOf(str) )
        {
            sessionStorage.removeItem(key);
        }
    }
}

//=================================================================
// データー加工用スクリプト
//=================================================================
/**
 * 表示年月日をセットする
 *
 * @param yyyymmdd YYYYMMDD形式の年月日
 */
export const setCurYYYYMMDD = function (yyyymmdd: string)
{
	// 年月日がnumberで渡された場合はStringに変換する
	if ( typeof yyyymmdd == "number" ) { yyyymmdd = String(yyyymmdd);}
	GVar.setCurYYYYMMDD(yyyymmdd);
	GVar.setCurYYYYMM(yyyymmdd.substring(0,6)); // 年月も設定する
}

/**
 * 年選択リストを作成
 * 無料会員の場合：１年前から１年後のリストを作成
 * 有料会員の場合：５年前から１年後のリストを作成
 *
 * @param selectListID HTML上のselectに割り当てたID
 * @param beginDate 開始年月日のDateオブジェクト
 * @param endDate   終了年月日のDateオブジェクト
 * @param selYYYY  現在選択されている年月(YYYY形式)
 */
export const createYYYYList = function (selectListID: string, beginDate: Date, endDate: Date, selYYYY: string)
{
    const bd = new Date(beginDate.getTime()); /* 開始年月日 */
	const ed = new Date(endDate.getTime()); /* 終了年月日 */
	let yyyySelected;
	const yyyyObj: any = document.getElementById(selectListID);
    // selectの内容を空にする
    if (yyyyObj.hasChildNodes()) {
        while (yyyyObj.childNodes.length > 0) {
            yyyyObj.removeChild(yyyyObj.firstChild)
        }
    }
	/* yyyyオプションを作成する */
    for (let i = 0; bd <= ed; i++ )
	{
        const yyyy = ed.getFullYear.toString();
        if ( selYYYY == yyyy )
        {
            yyyySelected = true;
		}
		else
		{
			yyyySelected = false;
		}
			yyyyObj.options[i] = new Option(yyyy, yyyy, false, yyyySelected);
            ed.setMonth(ed.getFullYear() -1);
	}
}

/**
 * Selectリストに値を入れる
 *
 * @param selObj selectリストオブジェクト
 * @param data データー
 */
export const createSelectList = function (selObj: any, data: any)
{
	for ( let i = 0; i < data.length; i++ )
	{
		selObj.options[i] = new Option(data[i].key, data[i].val);
	}
}

//=================================================================
// カレンダー用スクリプト
//=================================================================

/**
 * サーバーから月間カレンダーを取得してsessionstorageに記録する
 * 
 * @param dataType データータイプ(10:パーソナル、20：プライベートグループ、 30：パブリックグループ）
 * @returns 正常終了 - null, 異常終了 - メッセージコード（例: "msg.1001"）
*/
export async function getMonthlyCalendar(dataType: string)
{
    if ( isDebugEnabled() ) {console.log("getMonthlyCalendar()");}
	// パラメーターセット
    JC.commonHeader.actionFlag = getProperty("C010010.actionFlag.R")!;
    const c010010JC = new JC.C010010JC();
    c010010JC.prjNo = GVar.curPrjNo;            // プロジェクトNo.
    c010010JC.cntryCd = GVar.countryCd;      // 国コード.
    c010010JC.fromYyyymm = GVar.curYYYYMM;   // 取得開始年月
    c010010JC.toYyyymm = GVar.curYYYYMM;     // 取得終了年月
    await axios.post(GVar.getServerUrl2()+"/c010010", 
        JC.toJson(c010010JC),
        {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd == getProperty("JSON.STATUS.OK") )
        {
			//
			// sessionstorageにカレンダーを保存する
			//

            // サーバーから受信したイベントカレンダーを年月日ごとにsessionstorageに保存
			for ( let i = 0; i < rtn.eventCalendarDays.length; i++ )
			{
                storeGroupCalendarDay(rtn.uid, rtn.prjNo, dataType, rtn.eventCalendarDays[i]);
			}
            return null;
        }
        else
        {
            // エラー
            alert(rtn.msg);
            return rtn.msg;
        }
    })
    .catch(function (error) 
    {        
        // ネットワークエラー
        writeAxiosErrorLog(error);
        console.error("ネットワークエラー:"+GVar.getServerUrl2());
        alert(getProperty("msg.1001"));
        return getProperty("msg.1001");
    });
}

/**
 * 引数のイベントNo.を含む当該月のプロジェクトカレンダーをsessionStorage.セットし、
 * イベントアクション情報を返す
 *
 * @param evntNo イベントNo.
 * @return eventAction イベント情報又はnull
 */
export async function getProjCal(dataType: string, evntNo: number)
{
    if ( isDebugEnabled() ) {console.log("getProjCal() evntNo="+evntNo);}
	// パラメーターセット
    JC.commonHeader.actionFlag = getProperty("C010011.actionFlag.R")!;
    const c010011JC = new JC.C010011JC();
    c010011JC.evntNo = evntNo;            // イベントNo.
    let eventAction: any = null;               // イベントアクション
    await axios.post(GVar.getServerUrl2()+"/c010011", 
        JC.toJson(c010011JC),
        {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd == getProperty("JSON.STATUS.OK") )
        {
			//
			// sessionstorageにカレンダーを保存する
			//

            // サーバーから受信したカレンダーイベントカレンダーを年月日ごとにsessionstorageに保存
			for ( let i = 0; i < rtn.eventCalendarDays.length; i++ )
			{
                storeGroupCalendarDay(rtn.uid, rtn.prjNo, dataType, rtn.eventCalendarDays[i]);
                // 当該イベントの開催年月日を現在年月日にセットする
                if ( rtn.eventCalendarDays[i].eventActions != null )
                {
                    for ( let j = 0; j < rtn.eventCalendarDays[i].eventActions.length; j++ )
                    {
                        if ( rtn.eventCalendarDays[i].eventActions[j].evntNo == evntNo )
                        {
                            
                            eventAction = rtn.eventCalendarDays[i].eventActions[j];
                            GVar.setCurYYYYMMDD(eventAction.mpt025.evntStrtYmd);
                            break;
                        }
                    }
                }               
			}                        
        }
        else
        {
            // エラー
            alert(rtn.msg);
        }
    })
    .catch(function (error) 
    {        
        // ネットワークエラー
        writeAxiosErrorLog(error);
        console.error("ネットワークエラー:"+GVar.getServerUrl2());
        alert(getProperty("msg.1001"));
        return getProperty("msg.1001");
    });

    return eventAction;
}

/**
 * スワイプ用のイベントリスナーと関数を登録する
 *
 * @parama obj スワイプの対象となるオブジェクト
 * @parama func1 右から左にスワイプした場合に呼ばれる関数
 * @parama func2 左から右にスワイプした場合に呼ばれる関数
 */
export const addSwipeListner = function (obj: any, func1: any, func2: any)
{
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoveX = 0;
    let touchMoveY = 0;
    // スワイプを判断する移動量を定義
    const swipeMoveMin = window.innerWidth*Number(getProperty('SWIPE_MIN_MOVE_W_PERCENT'))/100;
    // スワイプ開始
    obj.addEventListener("touchstart", function(event: any) {
        // 座標の取得
        touchStartX = event.touches[0].pageX;
        touchStartY = event.touches[0].pageY;
    }, false);
    // スワイプ中
    obj.addEventListener("touchmove", function(event: any) {
        // 座標の取得
        touchMoveX = event.changedTouches[0].pageX;
        touchMoveY = event.changedTouches[0].pageY;
    }, false);
    // スワイプ終了
    obj.addEventListener("touchend", function(event: any) {
        // 移動量の判定
        if (touchStartX > touchMoveX && touchMoveX != 0) {
            if (touchStartX - touchMoveX > swipeMoveMin) {
                // 右から左にスワイプした場合
                func1();
            }
        } else if (touchStartX < touchMoveX && touchMoveX != 0) {
            if (touchMoveX - touchStartX > swipeMoveMin) {
                // 左から右にスワイプした場合
                func2();
            }
        }
        // 初期化
        touchStartX = touchStartY = touchMoveX = touchMoveY = 0;
    }, false);
}
//=================================================================
// イベントカレンダー用スクリプト
//=================================================================

/**
 * カレンダーの1日分をsessionStorageに保存する
 *
 * @param uid ユーザーID
 * @param prjNo プロジェクトNo.
 * @param dataType データータイプ(10:パーソナル、20：プライベートグループ、 30：パブリックグループ） 
 * @param eventCalendarDays カレンダーの1日分
 */
export function storeGroupCalendarDay(uid: string, prjNo: string, dataType: string, eventCalendarDay: any)
{
    // グループ用カレンダーの１日分オブジェクト作成
	// JSon形式でsessionStorageに保存
	const key = createLsKey(GVar.sysCd, GVar.tmpltCd, dataType, prjNo, eventCalendarDay.ymd);
	try{
		sessionStorage.removeItem(key);
		sessionStorage.setItem(key,JSON.stringify(eventCalendarDay));
	}catch(e){console.error(e);}
}

/**
 * 引数で受け取った年月日のカレンダーの1日分をsessionStorageから抽出する
 *
 * @param dataType データータイプ(10:パーソナル、20：プライベートグループ、 30：パブリックグループ） * 
 * @param prjNo プロジェクトNo.
 * @param YYYYMMDD形式の年月日
 * @return CalendarDayAndroidオブジェクト
 */
export function retrieveGroupCalendarDay(dataType:string, prjNo: number, yyyymmdd: string)
{
   return(JSON.parse(sessionStorage.getItem(createLsKey(GVar.sysCd, GVar.tmpltCd, dataType, String(prjNo), yyyymmdd))!));
}

/**
 * 現在選択されている年月日とイベント番号からsessionStorageにある該当のイベントアクションオブジェクトを返す
 *
 * @param dataType データータイプ(10:パーソナル、20：プライベートグループ、 30：パブリックグループ）
 * @param ymd localstrorageに保存されている年月日
 * @param eventNo localstrorageに保存されているイベントNo.
 * @param prjNo プロジェクトNo.
 * @returns イベントアクションオブジェクト又は、null
 */
export async function retrieveEventAction(dataType: string, ymd: string, eventNo: number, prjNo: number)
{
    if ( isDebugEnabled() ) console.log("retrieveEventAction()");
	if ( ymd == '' || eventNo == 0 ) return null;

	// sessionStorageから年月日をキーにCalendarDayオブジェクトを取得
    let cd = JSON.parse(sessionStorage.getItem(createLsKey(GVar.sysCd, GVar.tmpltCd, dataType, String(prjNo), ymd))!);
	for ( let i = 0; cd != null && cd.eventActions != null && i < cd.eventActions.length; i++ )
	{
		if ( eventNo == cd.eventActions[i].evntNo )
		{
            // イベントに紐づいているアクション番号を退避
            // if ( cd.eventActions[i].mpt016 != null ) { s05001003_curActNo =  cd.eventActions[i].mpt016.actNo; }
            // イベントを返す
            return cd.eventActions[i];
		}
	}
	// 当該の年月日がsessionStorageに保存されてないため、当該年月日を含む年月分のデーターを
	// サーバーから取得する
    let msg = null;
    if ( null != (msg = await getMonthlyCalendar(dataType)) )
	{
		// エラー
        console.error("retrieveEventAction error="+msg);
		return null;
	}
	// 再度sessionStorageから年月日をキーにCalendarDayオブジェクトを取得
    cd = JSON.parse(sessionStorage.getItem(createLsKey(GVar.sysCd, GVar.tmpltCd, dataType, String(prjNo), ymd))!);
	for ( let i = 0; cd != null && cd.eventActions != null && i < cd.eventActions.length; i++ )
	{
		if ( eventNo == cd.eventActions[i].evntNo )
		{
            // イベントに紐づいているアクション番号を退避
            // イベントを返す
			return cd.eventActions[i];
		}
	}
	return null;
}

//=================================================================
// ページ制御用スクリプト
//=================================================================

/**
 * 戻りページをセットする
 * @param page 戻りページのID （例） editPage
 */
export const setRtnPage = function (page: string)
{
    if ( isDebugEnabled() ) console.log("setRtnPage()");
	GVar.setRtnPage(page);
}

/**
 * 設定されている戻りページを返す
 *
 * @returns {String} 戻りページ
 */
export const getRtnPage = function ()
{
    if ( isDebugEnabled() ) console.log("getRtnPage()");
	return(GVar.rtnPage);
}

/**
 * Watingイメージ表示関数
 * @param msg 表示するメッセージ
 */
let waiting: any;
export const dispWating = async function (msg: string)
{

    waiting = await loadingController.create({
        message: msg
      });
      waiting.present();
}

/**
 * Watingイメージ削除
 */
export const removeWaiting = function ()
{
    waiting.dismiss();
}

//=================================================================
// カメラ、画像用スクリプト
//=================================================================

/**
 * 画像取出しエラー
 */
//function onFail(message)
//{ alert('Failed because: ' + message); }

/**
＊イメージの拡大
 *  imgElm IMGタグのエレメント
 *  mime_type MIMEタイプ(image/png)
 */
export function zoomInImage(imgElm: any, mime_type: string)
{
    // 倍率が最大倍率を超えた場合は拡大を行わない
    if ( GVar.curRatioImg >= Number(getProperty("graph.common.ratio.max")) )
    {
        alert(getProperty("msg.0063"));
        return;
    }
    //  拡大する
    const ratio = GVar.curRatioImg + Number(getProperty("graph.common.ratio.step"));
    GVar.setCurRatioImg(Math.round(ratio*10)/10);
    resamplingImage(imgElm, mime_type, GVar.curRatioImg)
}

/**
＊イメージの縮小
 *  imgElm IMGタグのエレメント
 *  mime_type MIMEタイプ(image/png)
 */
export function zoomOutImage(imgElm: any, mime_type: string)
{
    // 倍率が最大倍率を超えた場合は拡大を行わない
    if ( GVar.curRatioImg == 1 )
    {
        alert(getProperty("msg.0064"));
        return;
    }
    //  縮小する
    const ratio = GVar.curRatioImg - Number(getProperty("graph.common.ratio.step") );
    GVar.setCurRatioImg(Math.round(ratio*10)/10);
    resamplingImage(imgElm, mime_type, GVar.curRatioImg)
}

/**
＊イメージのリサンプリング
 */
export function resamplingImage(imgElm: any, mime_type: string, ratio: number)
{
    //  幅か高さが0のイメージはサイズ変更出来ない
    if ( imgElm.naturalWidth == 0 || imgElm.naturalHeight == 0 ) return;
    if ( GVar.cntResampling == 0 )
    {
        GVar.setCntResampling(GVar.cntResampling+1);
        // 初回のリサンプリングの時にオリジナルイメージを退避
        GVar.setOrgImgW(imgElm.naturalWidth);
        GVar.setOrgImgH(imgElm.naturalHeight);
        const el = document.createElement('canvas');
        el.width = GVar.orgImgW;
        el.height = GVar.orgImgH;
        GVar.setOrgCanvas(el);
        const orgCtx = el.getContext('2d');
        if ( orgCtx != null ) {orgCtx.drawImage(imgElm, 0, 0);}
    }
    // 新しいサイズを計算
    const w = Math.round(GVar.orgImgW * ratio);
    const h = Math.round(GVar.orgImgH * ratio);
    // 新しいCanvasを作成
    const newCanvas = document.createElement('canvas');
    // リサイズ
    const newCtx = newCanvas.getContext('2d');
    newCanvas.width = w;
    newCanvas.height = h;
    if ( newCtx != null ) {newCtx.drawImage(GVar.orgCanvas, 0, 0, GVar.orgImgW, GVar.orgImgH, 0, 0, w, h);}
    // Image Base64
    imgElm.src = newCanvas.toDataURL(mime_type);
}

/**
 * 
 * @param img イメージの縦横比を保ち縦、横の最大値に収まる様に縮小したBase64文字列を返す
 * @param maxWidth イメージの最大横幅
 * @param maxHeight イメージの最大高さ
 * @returns Base64データー
 */
export function resamplingImage2(img: any, maxWidth: number, maxHeight: number)
{
    if ( isDebugEnabled() ) {console.log("resampleImage()");}
    // MIME TYPE取得
    const imgType = img.src.substring(5, img.src.indexOf(';'));
    // 最大値との比率を求める
    const ratioWidth = maxWidth / img.naturalWidth; 
    const ratioHeight =  maxHeight / img.naturalHeight; 
    // リサイズ用キャンバス
    const canvas = document.createElement('canvas');
    if ( ratioWidth <= ratioHeight && ratioWidth < 1 )
    {
        // 横幅/最大値が高さ/最大値を上回ったため横幅の縮小率で計算する
        canvas.width  = maxWidth;
        canvas.height = Math.round(img.height * ratioWidth);
    }
    else if ( ratioWidth > ratioHeight && ratioHeight < 1 )
    {
        // 高さ/最大値が横幅/最大値を上回ったため高さの縮小率で計算する
        canvas.width  = Math.round(img.width * ratioHeight);
        canvas.height = maxHeight;
    }
    const ctx = canvas.getContext('2d')!;
    if ( ctx != null ) {ctx.drawImage(img, 0, 0, img.width, img.height , 0, 0, canvas.width, canvas.height);}
    // Image Base64に変換して返す
    return canvas.toDataURL(imgType);
}

//=================================================================
// 課金管理用スクリプト
//=================================================================

/**
 * 現在ログイン中のメモった！UIDで有料プランを購入済みか判断する
 *
 * @param strOptCd ストアーオプションコード
 * @return true - 購入済み、 false - 未購入
 */
export const productOwnedByMemottaUid = function (strOptCd: string)
{
        // 2023/1/11 TODO 要変更
        /*
        // パラメーターセット
        commonHeader.actionFlag = getProperty("C000100.actionFlag.R"); // アクションフラグセット
        var c000100JC = new C000100JC();
        c000100JC.sysCd = sysCd;             // システムコード
        c000100JC.tmpltCd = tmpltCd;         // テンプレートコード
        c000100JC.strOptCd = strOptCd;       // ストアーオプションコード
        // 有料オプション確認状況取得を呼び出す
        var rtn = false;
        $.ajax({
              url: GVar.getServerUrl2()+"/c000100",
              async: false,
              cache: false,
              contentType: 'application/json',
              type: "POST",
              data: toJson(c000100JC),
              dataType: "json"
              })
              .done(function(c000100Rtn)
              {
                // メッセージ表示
                if ( c000100Rtn.sttsCd != getProperty("JSON.STATUS.OK") )
                {
                    // エラー
                    console.error(c000100Rtn.msg);
                }
                else if (c000100Rtn.qualified ) { rtn = true; }
              })
              .fail(function(xhr, status, err)
              {
                // ネットワークエラー
                console.error(getProperty("msg.1001"));
                alert(getProperty("msg.1001"));
              });
         return rtn;
         */
}

/**
 * 現在ログイン中のGooglePlay又はAppleStoreのIDで有料プランを購入済みか判断する
 *
 * @return true - 購入済み、 false - 未購入
 */
export const productOwnedByStoreUid = function ()
{
    if ( GVar.memottaProduct == null ) { return false; }
    return GVar.memottaProduct.owned;
}

/**
 * 有料プランユーザーがプロジェクトの所有者か判断する
 *
 * @param strOptCd ストアーオプションコード
 * @param prjNo プロジェクトNo.
 * @return true - 有料プランユーザーが所有者、 false - 無料プランユーザーが所有者
 */
export const projectOwnedByPremiumUser = function (strOptCd: string, prjNo: number)
{
    // 2023/1/11 TODO 要変更
    /*
        // パラメーターセット
        commonHeader.actionFlag = getProperty("C000160.actionFlag.R"); // アクションフラグセット
        var c000160JC = new C000160JC();
        c000160JC.sysCd = sysCd;             // システムコード
        c000160JC.tmpltCd = tmpltCd;         // テンプレートコード
        c000160JC.strOptCd = strOptCd;       // ストアーオプションコード
        c000160JC.prjNo = prjNo;       // プロジェクトNo.
        // 有料オプション確認状況取得を呼び出す
        var rtn = false;
        $.ajax({
              url: GVar.getServerUrl2()+"/c000160",
              async: false,
              cache: false,
              contentType: 'application/json',
              type: "POST",
              data: toJson(c000160JC),
              dataType: "json"
              })
              .done(function(c000160Rtn)
              {
                // メッセージ表示
                if ( c000160Rtn.sttsCd != getProperty("JSON.STATUS.OK") )
                {
                    // エラー
                    console.error(c000160Rtn.msg);
                }
                else if (c000160Rtn.qualified ) { rtn = true; }
              })
              .fail(function(xhr, status, err)
              {
                // ネットワークエラー
                console.error(getProperty("msg.1001"));
                alert(getProperty("msg.1001"));
              });
         return rtn;
         */
}

//=================================================================
// 再発行用スクリプト
//=================================================================

/**
 * 仮パスワードを発行する
 * @param email パスワード発行対象のメールアドレス
 */
export const renewPwd = function (email: string)
{
    if ( isDebugEnabled() ) {console.log("renewPwd()");}
    // 入力チェック
    if ( email == null || email.length == 0 )
    {
        alert(getProperty("msg.0036"));
        return;
    }
    if (!confirm(getProperty("msg.0096",email))){return;}
    // パラメーターセット
    JC.setCommonHeader(new JC.CommonHeader(0, "", GVar.langCd, GVar.countryCd, GVar.ttype, GVar.sysCd, GVar.tmpltCd));
    JC.commonHeader.setActionFlag(getProperty("C000080.actionFlag.U")!);
    const c000080JC = new JC.C000080JC();
    c000080JC.setEmail(email);   // パスワード発行対象のメールアドレス
    // 処理を呼び出す
    axios.post(GVar.getServerUrl2()+"/c000080",
        JC.toJson(c000080JC),
        {headers: {"content-type": "application/json"}})
        .then( response =>
        {
            if ( isDebugEnabled() ) { console.log(response); }
            const rtn = response.data;
            // ステータスチェック
            if ( rtn.sttsCd == getProperty("JSON.STATUS.OK") )
            {
                // メッセージ表示
                alert(getProperty("msg.0097",email));
            }
            else
            {
                // エラー
                alert(rtn.msg);
            }
        })
        .catch(err =>
        {
            // ネットワークエラー
            alert(getProperty("msg.1001")+":"+err);
        });
}

//=================================================================
// PUSH通知用スクリプト
//=================================================================

/**
 * ユーザー保有端末情報登録
 */
export const saveTrmnlTkn = function (token: string)
{
    if ( isDebugEnabled() ) {console.log("saveTrmnlTkn()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = getProperty("C000090.actionFlag.C")!;
    const c000090JC = new JC.C000090JC();
    //
    // ユーザー保有端末情報(MPT040)
    //
    const mpt040 = new JC.Mpt040();
    c000090JC.mpt040 = mpt040;
    const mpt040PK = new JC.Mpt040PK();
    mpt040.id = mpt040PK;
    mpt040PK.uid = getUi().uid.value;   // ユーザーID
    mpt040PK.sysCd = GVar.sysCd;                     // システムコード
    mpt040PK.tmpltCd = GVar.tmpltCd;                 // テンプレートコード
    mpt040PK.trmnlId = GVar.deviceId;             // 端末ID
    mpt040.trmnlTkn = token;                    // トークン
    mpt040.trmnlTyp = GVar.ttype;                    // 端末タイプ

    axios.post(GVar.getServerUrl2()+"/c000090", 
        JC.toJson(c000090JC),
        {headers: {"content-type": "application/json"}})
        .then(function (response) 
        {
            if ( isDebugEnabled() ) { console.log(response); }
            const rtn = response.data;
            // ステータスチェック
            if ( rtn.sttsCd != getProperty("JSON.STATUS.OK") )
            {
                alert(rtn.msg);
            }
        })
        .catch(function (error) 
        {
            // ネットワークエラー
            writeAxiosErrorLog(error);
            console.error("ネットワークエラー:"+GVar.getServerUrl2());
            alert(getProperty("msg.1001"));
        });
}

//=================================================================
// グループ参加状況取得用スクリプト
//=================================================================

/**
 * 特定ユーザーのグループ参加状況一覧を返す
 *
 * @param uid ユーザーID
 * @return 参加状況一覧 C000120JCオブジェクト
 */
export const getGroupParticipationList = function (uid: number)
{
    // 2023/1/11 TODO 要変更
    /*
    // ログインチェック
    if ( 0 != checkLogin() )
    {
        s00001012_show(getRtnPage(), getProperty("msg.1002"));
        return;
    }
    // パラメーターセット
    commonHeader.actionFlag = getProperty("C000120.actionFlag.R");
    var c000120JC = new C000120JC();
    c000120JC.memUid = uid; // ユーザーID
    c000120JC.sysCd = sysCd;        // システムコード
    c000120JC.tmpltCd = tmpltCd;    // テンプレートコード
    // 検索処理を呼び出す
    // 自分の保持する全グループを検索するので検索条件は設定しない
    var rtn = null;
	$.ajax({
		  url: GVar.getServerUrl2()+"/c000120",
		  async: false,
		  cache: false,
		  contentType: 'application/json',
		  type: "POST",
		  data: toJson(c000120JC),
		  dataType: "json"
		  })
		  .done(function(c000120Rtn)
		  {
			// ステータスチェック
			if ( c000120Rtn.sttsCd != getProperty("JSON.STATUS.OK") )
			{
			 	// エラー
				alert(c000120Rtn.msg);
				return;
			}
			// グループ参加状況一覧の表示
			rtn = c000120Rtn;
		  })
		  .fail(function(xhr, status, err)
		  {
		    // ネットワークエラー
			alert(getProperty("msg.1001"));
		  }
	);
	return(rtn);
    */
}

/**
 * 特定ユーザーの招待状未回答有無を取得する
 * グループが1件でもあれば、先頭グループを選択済みにする
 *
 * @param uid ユーザーID
 * @return true - あり、 false - なし
 */
export const isRespondedToGroupInvitation = function (uid: number)
{
    // 2023/1/11 TODO 要変更
    /*
    var notResponded = false;
    // 所属グループがあれば先頭グループを選択済みにする
    JC.setC000120KeepIdx(-1);
    JC.setC000120Keep(getGroupParticipationList(getUi()().uid.value));
    if ( JC.c000120Keep.mpv003s.length > 0 )
    {
        // 未回答有無を調べる
        for (var i = 0; i < JC.c000120Keep.mpv003s.length; i++)
        {
            if ( JC.c000120Keep.mpv003s[i].mbrInvtSttsCd == getProperty('invitation.status.sent') )
            {
                // 未回答あり
                notResponded = true;
            }
            if ( JC.c000120Keep.mpv003s[i].mbrInvtSttsCd == getProperty('invitation.status.approved') )
            {
                // 先頭の参加済みグループを選択済みにする
                if ( JC.c000120KeepIdx == -1 ) { JC.setC000120KeepIdx(i); }
            }
        }
    }
    return(notResponded);
    */
}

//=================================================================
// Google Maps API用スクリプト
//=================================================================

/**
 * 地図を表示する
 * @param id 地図を表示するエレメントID
 * @param addr 経度、緯度取得用の住所
 * @param desc 地図上のマークをクリックしたときに表示される説明（HTMLタグで記述）
 */
export const drawMap = async function (id: Element, addr: string, desc: string)
{
    if ( isDebugEnabled() ) {console.log("drawMap()");}
    await axios.get(GVar.mapGeoApiUrl,
     {params: {
        address : addr,
        language : 'ja',
        country : 'JP',
        sensor : false,
        key : GVar.apiKeys[Capacitor.getPlatform()]
    }})
    .then(function (response) 
    {
        if ( isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.status == "OK" )
        {
            // 地図描画を呼び出す
            drawMap2(id, rtn.results[0].geometry.location.lat, rtn.results[0].geometry.location.lng, desc);
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        writeAxiosErrorLog(error);
        console.error("ネットワークエラー:"+GVar.getServerUrl2());
        alert(getProperty("msg.1001"));
    })
    ;
}

/**
 * 地図を描画する
 * @param id 地図を表示するエレメントID
 * @param lat 経度
 * @param lng 緯度
 * @param desc 地図上のマークをクリックしたときに表示される説明（HTMLタグで記述）
 */
function drawMap2(id: Element, lat: number, lng: number, desc: string)
{   
    if ( isDebugEnabled() ) {console.log("drawMap2()");}
    const loader = new Loader(GVar.apiKeys[Capacitor.getPlatform()]);
    loader.load().then(function (google) {
        // 経度、緯度を設定
        const latlng = new google.maps.LatLng(lat, lng);
        // オプション設定
        const opts = {
            zoom: 15,
            center: latlng,
            language: 'ja',
            region: 'JP',
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        // 描画
        const map = new google.maps.Map(id, opts);
        // マーカーを表示
        const marker = new google.maps.Marker({
            position: latlng,  // 経度、緯度
            map: map            // 地図
        });
        // 吹き出しオブジェクトの作成
        const infoWindow1 = new google.maps.InfoWindow({
            content: desc
        });
        // 初期表示で吹き出しを表示する
        infoWindow1.open(map, marker);
        // マーカーのクリックイベント
        marker.addListener('click', ()=> {
            infoWindow1.open(map, marker); // 吹き出し表示
        });
    });
}


//=================================================================
// sessionStorageアクセス用
//=================================================================
/**
 * sessionStorage保存用キー作成
 * キーの形式： システムコード+テンプレートコード+"@"+データータイプ+"@"+データー識別キー
 *
 * @param sysCd システムコード
 * @param tmpltCd テンプレートコード
 * @param dataType データータイプ(10:パーソナル、20：プライベートグループ、 30：パブリックグループ）
 * @param ID ユーザーID又はプロジェクトNo.
 * @param key データー識別キー(YYYYMMDD又はYYYYMM）
 */
export function createLsKey(sysCd: string, tmpltCd: string, dataType: string, id: string, key: string)
{
	return(sysCd+tmpltCd+"@"+dataType+"@"+id+"@"+key);
}

/**
 * sessionStorage.ロジェクト情報保存用キー作成
 * キーの形式： システムコード+テンプレートコード+"@"+データータイプ+"@"+データー識別キー
 *
 * @param sysCd システムコード
 * @param tmpltCd テンプレートコード
 * @param dataType データータイプ(10:パーソナル、20：プライベートグループ、 30：パブリックグループ）
 * @param uid ユーザーID
 * @param IprjNo プロジェクトNo.
 * @param key データー識別キー(YYYYMMDD又はYYYYMM）
 */
//function createPrjLsKey(sysCd, tmpltCd, dataType, uid, prjNo, key)
//{
//	return(sysCd+tmpltCd+"@"+dataType+"@"+uid+"@"+prjNo+"@"+key);
//}

/**
 * カレンダーデータをsessionStorageから削除する
 */
export function clearCalendarData()
{
    // sessionStorageをクリアする前にui情報を退避する
    const ui: any = sessionStorage.getItem(getUiKey());
    // sessionStorageをクリアする
    sessionStorage.clear();
    // ui情報をsessionStorageに戻す
    sessionStorage.setItem(getUiKey(),ui);
}

//=================================================================
// バーコード用スクリプト
//=================================================================

/**
 * バーコードコードを描画
 * @param cc クーポンコード
 * @return base64のバーコード
 */
export async function getBC64(cc: string)
{
    if ( isDebugEnabled() ) {console.log("getBC64()");}
    let barcode = "";
	// パラメーターセット
    JC.commonHeader.actionFlag = getProperty("B000010.actionFlag.R")!;
    const b000010JC = new JC.B000010JC();
    b000010JC.brCdFmt = getProperty("barcode.format.nw7")!;	// バーコードフォーマット
    b000010JC.dspCd = cc;	    // 表示コード
    await axios.post(GVar.getServerUrl2()+"/b000010", 
        JC.toJson(b000010JC),
        {headers: {"content-type": "application/json"}})
        .then(function (response) 
        {
            if ( isDebugEnabled() ) { console.log(response); }
            const rtn = response.data;
            if ( rtn != "" ) 
            { barcode = 'data:image/png;base64,'+rtn; }
        })
        .catch(function (error) 
        {
            // ネットワークエラー
            writeAxiosErrorLog(error);
            console.error("ネットワークエラー:"+GVar.getServerUrl2());
            alert(getProperty("msg.1001"));
        })
        ;
        return(barcode);
}

//=================================================================
// エラー処理
//=================================================================

/**
 * axios呼び出し時に発生したエラーをログに書く
 * @param error エラー
 */
export function writeAxiosErrorLog(error: any)
{
    if (error.response) 
    {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    } 
    else if (error.request) 
    {
        console.log(error.request);
    } 
    else 
    {
        console.log('Error', error.message);
    }
    console.log(error.config);
}

//=================================================================
// その他
//=================================================================

/**
 * お知らせがあれば表示し、トップページに遷移する
 *
 * @param uid ユーザーID
 * @param sysCd システムコード
 * @param tmpltCd テンプレートコード
 * @param nextPage お知らせ表示後に遷移するページ
 */
export const showNorifications = async function (uid: number, sysCd: string, tmpltCd: string, nextPage: string)
{
    if ( isDebugEnabled() ) {console.log("showNorifications()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = getProperty("C000150.actionFlag.R")!;
    const c000150JC = new JC.C000150JC();
    // c000150JC.sysCd = sysCd;        // システムコード
    // c000150JC.tmpltCd = tmpltCd;    // テンプレートコード
    // 検索処理を呼び出す
    // 自分の保持する全グループを検索するので検索条件は設定しない
    await axios.post(GVar.getServerUrl2()+"/c000150", 
        JC.toJson(c000150JC),
        {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd != getProperty("JSON.STATUS.OK"))
        {
            // エラー
            alert(rtn.msg);
            return;
        }
        // お知らせがあるかチェック
        if ( rtn.outMpt059s == null || rtn.outMpt059s.length == 0 )
        {
            // お知らせが無いので先頭ページへ遷移する
            router.replace({name:nextPage});
            return;
        }
        // お知らせ編集
        const msgs = [];
        for (let i = 0; i < rtn.outMpt059s.length; i++)
        {
            const rec = rtn.outMpt059s[i];
            msgs.push(new GVar.s00001012Msg(rec.ntfyTtl , rec.ntfyCntnt));
        }
        // お知らせ表示
        if ( msgs.length > 0 )
        {
            GVar.setS00001012Nextpage(nextPage); // お知らせ表示後の遷移先
            GVar.setS00001012Msgs(msgs);    // お知らせ
            router.replace({name:'S00001012'});
        }
        else {router.replace({name:nextPage});}
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        writeAxiosErrorLog(error);
        console.error("ネットワークエラー:"+GVar.getServerUrl2());
        alert(getProperty("msg.1001"));
    });
}
/*
export const showHelp = async function(help: any)
{
    const modal = await modalController.create({
        component: () => import(help)
        // component: Modal,
      });
      modal.present();
}
*/

/**
 * タイトルバーに表示するニックネームを返す
 */
export const getNicknameOnTitlebar = function()
{
  if( isLoggedin() )
  { 
    // ログイン中
    return getProperty("screen.common.label.loggedin")+":"+getUi().nckNm.value; 
  }
  else
  {
    // ログインしないで使用中 
    return getProperty("screen.common.label.nologin"); 
  }
}

/**
 * 役割によるパーミッションを返す
 * @param sysCd システムコード
 * @param tmpltCd テンプレートコード
 * @param pageId 画面ID
 * @param fnctCd 機能コード
 * @param rllCd 役割コード
 * @param permission パーミッション
 */
export async function hasPermission(sysCd:string, tmpltCd:string, pageId:string, fnctCd:string, rllCd:string, permission:any){
    if ( isDebugEnabled() ) {console.log("get()");}
    let rtn = null;
    let result = false;
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c000210JC = new JC.C000210JC();
    c000210JC.sysCd = sysCd;     // システムコード
    c000210JC.tmpltCd = tmpltCd;  // テンプレートコード
    c000210JC.pageId = pageId;      // 画面ID
    c000210JC.fnctCd = fnctCd;   // 機能コード
    c000210JC.rllCd = rllCd;    // 役割コード
    // 取得処理を呼び出す
    await axios.post(GVar.getServerUrl2()+"/c000210", 
    JC.toJson(c000210JC),
    {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( isDebugEnabled() ) { console.log(response); }
        rtn = response.data;
        // 受け取ったパーミッションをR,W,Xに区別して返す
        // パーミッションがnullの場合false
        if(rtn.mpt067 != null){
            // 参照パーミッションがある場合その値を返す
            if(permission == Const00.map.get('permission.r')){
                result = rtn.mpt067.prmsnR;
            }
            // 更新パーミッションがある場合その値を返す
            else if(permission == Const00.map.get('permission.w')){
                result = rtn.mpt067.prmsnW;
            }
            // 実行パーミッションがある場合その値を返す
            else if(permission == Const00.map.get('permission.x')){
                result = rtn.mpt067.prmsnX;
            }
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        writeAxiosErrorLog(error);
        alert(getProperty("msg.1001"));
    })
    ;
    return result;
}